var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ComponentContext } from '../Context/ComponentContext';
import { ReduxContext } from '../Context/ReduxContext';
export function withContext(WrappedComponent) {
    const ComponentWithContext = (props) => {
        const { context, data, config, reduxContext } = props, otherProps = __rest(props, ["context", "data", "config", "reduxContext"]);
        if (!config)
            return React.createElement(WrappedComponent, Object.assign({}, otherProps));
        ComponentWithContext.displayName = config.name;
        let reactReduxContext = undefined;
        if (reduxContext)
            reactReduxContext = reduxContext.__redux_context__;
        if (!reactReduxContext) {
            return (React.createElement(ComponentContext.Provider, { value: context },
                React.createElement(WrappedComponent, Object.assign({ data: data }, otherProps))));
        }
        return (React.createElement(ComponentContext.Provider, { value: context },
            React.createElement(ReduxContext.Provider, { value: reduxContext },
                React.createElement(WrappedComponent, Object.assign({ context: reactReduxContext, data: data }, otherProps)))));
    };
    return ComponentWithContext;
}
//# sourceMappingURL=withContext.js.map